import { Module } from "vuex";
import { RootState } from "../types";
import { PaymentState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: PaymentState = {};

const namespaced: boolean = true;

export const payment: Module<PaymentState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
